module.exports = __webpack_public_path__ + "static/media/lock.c276a0c4.svg";